<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">Convert DNA To Protein Sequence</div>
    <form [formGroup]="ccsForm" (ngSubmit)="getDrugInfo()">
        <div class="form-group">
            <div class="textarea-div">
                <div style="display:flex; align-items: center;">
                    <div style="font-weight: bold;">Enter your Sequence for conversion.</div>
                    <mat-icon
                        matTooltip="Enter your Sequence for conversion in the format 'ACTGctga'. Allowed characters are [A|a|C|c|G|g|T|t], codons containing other characters will be converted to '?'. If the last codon is not complete the protein sequence will also end with a '?' symbol."
                        matTooltipPosition="right" style="transform: scale(0.8);">help</mat-icon>
                </div>
                <textarea class="form-control" id="inputName" formControlName="inputName"
                    placeholder="Enter your Sequence for conversion in the format 'ACTGTTACG' or click 'Load Example'"></textarea>
            </div>
            <div>
                <div>
                    <button type="button" class="btn btn-secondary" matTooltip="Info about the action"
                        matTooltipPosition="right" (click)="getExampleData()">Load Example</button><br>
                    <button type="submit" class="btn btn-primary" [disabled]="!ccsForm.valid">Submit</button>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="complete_request!=''">
    <app-terminal-view [terminal_string]="complete_request"></app-terminal-view>
</div>

<div class="card-grid" *ngIf="reqObj != null">
    <div class="card" *ngFor="let element of reqObj.data">
        <div class="card-header">
            <h2>{{element.name}}</h2>
        </div>
        <ul *ngIf="element['response']==200">
            <li *ngIf="element['warning']" style="color:red;margin-bottom: 20px;">Warning:<br><div style="font-family: monospace; font-weight: 200; margin:10px 0 0 0">{{element['warning']}}</div></li>
            <li style="margin-bottom: 20px;">One-Letter Sequence:<br><div style="font-family: monospace; font-weight: 200;margin:10px 0 0 0">{{element['one_letter_seq']}}</div></li>
            <li>Three-Letter Sequence:<br><div style="font-family: monospace; font-weight: 200;margin:10px 0 0 0">{{element['three_letter_seq']}}</div></li>
                    </ul>
        <ul *ngIf="element['response']==400">
            <li style="color:red;">Error: {{element['error']}}</li>
        </ul>
    </div>
</div>